import { useEffect, useMemo, useState } from 'react';
import { useMeasure } from 'react-use';
import { observer } from 'mobx-react-lite';
import { Document, Page } from 'react-pdf';
import { HelperCore } from '@/common/dependencies';
import { SVGPureIcon } from '@/ui';
import { Tooltip, Skeleton } from 'antd';
import EE from '@/common/event';
import QrcodeShare from '../qrcode-share';
import fullScreenModalStore from '../full-screen-modal/store';
import copy from 'copy-to-clipboard';
import Other from '@/common/helper/other';
import "./index.scss";

const CardPdf = observer((props) => {
  const {
    url,
    hasToolBar,
    event,
    cid,
  } = props;

  const fileName = event?.title || `${+new Date}.pdf`;
  const shareUrl = event?.share_url || url;

  const [numPages, setNumPages] = useState(1);
  const [isError, setIsError] = useState(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [$refDocumentContentContainer, { width: widthDocumentContentContainer, height: heightDocumentContentContainer }] = useMeasure();

  const play = (val) => {
    const step = pageIndex + val;
    if (step >= 1 && step <= numPages) {
      setPageIndex(step);
    }
  }

  const onDocumentLoadSuccess = (data) => {
    const { numPages } = data;
    setNumPages(numPages);
    // EE.emit("vnc-cards-scroll");
  }

  const onDocumentLoadError = () => {
    HelperCore.log(`PDF onDocumentLoadError`, url);
    setIsError(true);
  }

  const DocumentState = (content) => {
    return (
      <div className='w-full h-full flex flex-col items-center justify-center'>
        <div className="leading-20px text-14px">{content}</div>
      </div>
    )
  };

  const downloadFile = async () => {
    if (/^https/.test(url)) {
      let _fileName = fileName;
      // 如果fileName没有文件后缀，则从url里取
      if (!/(\.[a-z]{1,4})(?:$|\?)/gi.test(_fileName) && /(\.[a-z]{1,4})(?:$|\?)/gi.test(url)) {
        _fileName = fileName + RegExp.$1;
      }
      if (/qiniu/.test(url)) {
        const urlObj = new URL(url);
        const params = urlObj.searchParams;
        if (!params.get('attname')) {
          params.set('attname', encodeURIComponent(_fileName))
        }
        HelperCore.saveFile(urlObj.href, _fileName)
      }
      else if (/xstore/.test(url)) {
        const urlObj = new URL(url);
        const params = urlObj.searchParams;
        if (!params.get('response-content-disposition')) {
          params.set('response-content-disposition', 'attname');
          params.set('filename', encodeURIComponent(_fileName))
        }
        HelperCore.saveFile(urlObj.href, _fileName)
      }
      else {
        if(HelperCore.isWeixin()){
          HelperCore.saveFile(url, _fileName);
        }else{
          const blob = await fetch(url).then(res => res.blob()).catch(err => null);
          if (blob) {
            const url = URL.createObjectURL(blob);
            HelperCore.saveFile(url, _fileName);
            URL.revokeObjectURL(url);
          }
        }
        
      }
    }
  }

  return (
    <>
      {
        isError
        ? null
        : (
          <div className={`h-64px px-24px pt-15px flex justify-between items-center ${hasToolBar ? 'absolute right-0 top-5px pt-0 z-1' : ''}`}>
            <div className='flex-1'></div>
            {/* <Tooltip title="上一页" destroyTooltipOnHide>
              <div
                onClick={
                  () => play(-1)
                }
              >
                <SVGPureIcon
                  name="swiper_agent_prev"
                  className={`size-24px cursor-pointer hover:bg-[#f7f7f7] rounded-6px ${pageIndex === 1 ? 'text-black text-opacity-20' : ''}`}
                />
              </div>
            </Tooltip>
            <div className="h-28px leading-28px px-10px mx-8px bg-black bg-opacity-4 rounded-6px">{pageIndex} / {numPages}</div>
            <Tooltip title="下一页" destroyTooltipOnHide>
              <div
                onClick={
                  () => play(1)
                }
              >
                <SVGPureIcon
                  name="swiper_agent_next"
                  className={`size-24px cursor-pointer hover:bg-[#f7f7f7] rounded-6px ${pageIndex === numPages ? 'text-black text-opacity-20' : ''}`}
                />
              </div>
            </Tooltip> */}
            <Tooltip 
              title={
                <QrcodeShare url={shareUrl} />
              } 
              color="white"
              placement="bottomLeft"
              arrow={false}
              getPopupContainer={node => node}
              destroyTooltipOnHide
            >
              <div 
                className='h-28px box-border rounded-6px border-1px border-black border-opacity-16 leading-26px px-10px cursor-pointer hover:bg-[rgba(0,0,0,0.03)] mr-6px text-14px text-black card-share-btn'
                onClick={() => {
                  const copied = copy(shareUrl);
                  copied && Other.toast('复制成功', "success");
                }}
              >
                分享
              </div>
            </Tooltip>
            <div 
              className={`
                h-28px box-border rounded-6px border-1px border-black
                border-opacity-16 leading-26px px-10px cursor-pointer
                hover:bg-[rgba(0,0,0,0.03)] mx-8px text-14px text-black
                flex items-center
                ${HelperCore.isPhone() ? "border-0px px-0px" : ""}
              `}
              onClick={() => {
                fullScreenModalStore.setData({
                  show: true, 
                  type: "pdf",
                  data: {
                    shareUrl,
                    url,
                    fileName,
                  }
                });
              }}
            >
              <SVGPureIcon
                name="full_screen_modal_full2"
                className={`size-16px ${!HelperCore.isPhone() ? "mr-6px" : ""}`}
              />
              {
                !HelperCore.isPhone()
                ? "全屏"
                : null
              }
            </div>
            <Tooltip 
              title={
                HelperCore.isPhone()
                ? null
                : <QrcodeShare url={url} />
              } 
              color="white"
              placement="bottomLeft"
              arrow={false}
              getPopupContainer={node => node}
              destroyTooltipOnHide
            >
              <div 
                className={`
                  h-28px box-border rounded-6px border-1px border-black
                  border-opacity-16 leading-26px px-10px cursor-pointer
                  hover:bg-[rgba(0,0,0,0.03)] mr-8px text-14px text-black
                  flex items-center
                  ${HelperCore.isPhone() ? "border-0px px-0px" : ""}
                `}
                onClick={() => {
                  const copied = copy(url);     
                  copied && Other.toast('复制成功', "success");
                }}
              >
                <SVGPureIcon
                  name="full_screen_modal_share2"
                  className={`size-16px ${!HelperCore.isPhone() ? "mr-6px" : ""}`}
                />
                {
                  !HelperCore.isPhone()
                  ? "分享"
                  : null
                }
              </div>
            </Tooltip>
            <Tooltip destroyTooltipOnHide>
              <div
                className={`
                  h-28px box-border rounded-6px border-1px border-black
                  border-opacity-16 leading-26px px-10px cursor-pointer
                  hover:bg-[rgba(0,0,0,0.03)] text-14px text-black
                  flex items-center
                  ${HelperCore.isPhone() ? "border-0px px-0px" : ""}
                `}
                onClick={e => {
                  downloadFile()
                }}
              >
                <SVGPureIcon
                  name="download"
                  className="size-18px cursor-pointer "
                />
                {
                  !HelperCore.isPhone()
                  ? "下载"
                  : null
                }
              </div>
            </Tooltip>
          </div>
        )
      }
      <div
        className={`card-pdf flex-1 overflow-x-hidden overflow-y-auto scrollbar`}
        style={{
          aspectRatio: 9/11
        }}
        ref={$refDocumentContentContainer}
      >
        <Document 
          file={url} 
          className=""
          externalLinkTarget="_blank"
          loading={
            <div className="ml-16px">
              <Skeleton active />
            </div>
          }
          error={DocumentState('文档加载失败')}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={onDocumentLoadError}
        >
          {
            Array.from(new Array(numPages),
              (item, index) => {
                const _index = index + 1;
                return (
                  <Page
                    key={`page_${_index}`}
                    pageNumber={_index}
                    loading={null}
                    className="page flex justify-center items-center"
                    width={widthDocumentContentContainer}
                    // scale={0.8}
                  />
                )
              })
          }
        </Document>
      </div>
    </>
  )
});

export default CardPdf;